<mat-form-field  class="w-full">
  <mat-label>{{ props.label }}</mat-label>
  <mat-select [formControl]="formControl" [required]="props.required!">
    @for (inventory of inventorys$(); track inventory.id) {
    <mat-option [value]="inventory">
      {{ inventory.itemDescription }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>
